import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { hrReportSearchFrom } from '@/features/hr-reports/api'
import { HolidayRollScreen } from '@/features/hr-reports/holiday-roll-screen'
import { hasGrant } from '@/lib/me'
export const Route = createFileRoute('/_authenticated/hr/reports/holiday-roll')({
  validateSearch: (s: Record<string, unknown>) => hrReportSearchFrom(s),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: RouteScreen,
})
function RouteScreen() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <HolidayRollScreen
      search={search}
      onSearchChange={(next) => void navigate({ to: '/hr/reports/holiday-roll', search: next })}
    />
  )
}
